import React, { FunctionComponent, useCallback } from 'react';
import { MeetingsFolder } from '../MeetingsFolder';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { IMeeting } from '../../../../../app/resource/meeting/meeting.types';
import { openDialog } from '../../../../../app/dialog/dialog.actions';
import { useSelect } from '../../../../../utils/selector.utils';
import {
  IMeetingFolder,
  IMeetingSubFolder,
} from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.types';
import {
  teamFilesSelectedFolderlMeetingDashboardPage,
  teamFilesOnDeselectFolderlMeetingDashboardPage,
} from '../../../../../app/page/meeting-dashboard/meeting-dashboard.actions';
import { meetingFilesSelectors } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.selectors';

export const MeetingsFoldersShortcutsBrowser: FunctionComponent = () => {
  const { meetingId } = useParams<{ meetingId: IMeeting['id'] }>();

  const foldersFiles = useSelect(meetingFilesSelectors.selectResourceList);
  const foldersFilesParent = foldersFiles
    .filter((folder) => folder.meetingId === meetingId)
    .filter((foldersFile) => !foldersFile.parentId);

  const dispatch = useDispatch();

  const onSelectChange = (folder: IMeetingFolder | IMeetingSubFolder, select: boolean) => {
    if (select) {
      dispatch(teamFilesSelectedFolderlMeetingDashboardPage(meetingId, folder));
    } else {
      dispatch(teamFilesOnDeselectFolderlMeetingDashboardPage(meetingId));
    }
  };

  const openAddFolderFormDialog = useCallback(() => {
    dispatch(openDialog('meetingShortcutAddFolderDialog'));
  }, [dispatch]);

  return (
    <>
      <h5 className="bold mb-1 flex aic jcsb">TEAM FILES</h5>
      {foldersFilesParent?.map((folder) => (
        <MeetingsFolder key={folder.id} folder={folder} onSelectChange={onSelectChange} />
      ))}
      <button
        className="directory-button panel small-panel blueGray flex aic px-1"
        title=""
        onClick={openAddFolderFormDialog}
      >
        <i className="icon-plus mr-1 blueGray f-2" /> New Folder
      </button>
    </>
  );
};
